import { SxProps, Theme } from '@mui/material';

export const styles: Record<'container', SxProps<Theme>> = {
  container: {
    alignItems: 'center',
    backgroundColor: (theme) => theme.palette.background.paper,
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    justifyContent: 'space-between',
    padding: (theme) => ({
      sm: theme.spacing(3, 4, 2, 4),
      xs: theme.spacing(3, 2, 2, 2),
    }),
    width: '100%',
  },
};
